import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchUpdateMilestone = createAsyncThunk("fetchUpdateMilestone", async ({ id, data }, { rejectWithValue }) => {
	try {
		const token = localStorage.getItem("auth_token");
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};
		const response = await axiosHttp.post(`milestone/update/${id}`, data, config);

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const updateMilestoneSlice = createSlice({
	name: "updateMilestoneSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
	},

	reducers: {
		resetMilestoneUpdateState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchUpdateMilestone.pending, (state, action) => {
			state.isError = false;
			state.isLoading = true;
		});

		builder.addCase(fetchUpdateMilestone.fulfilled, (state, action) => {
			state.isError = false;
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchUpdateMilestone.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetMilestoneUpdateState } = updateMilestoneSlice.actions;
export default updateMilestoneSlice.reducer;
